import axios from 'axios';
let url = '';
if (process.env.NODE_ENV === 'development') {
    url = "http://openapi-local.39.net";
    
}
else {
   url="https://interface.39.net/openapi";
}
export const baseUrl = url;

//接口
export const getProducerList = params => { return axios.get(`${baseUrl}/app/getvaccinecompany?app_key=yimiao&sign=9E50861DF7A7E13078DDA8C8FA0DAA11`, { params: params }); };
export const checking = params => { return axios.get(`${baseUrl}/app/getvaccineresult?app_key=yimiao&sign=9E50861DF7A7E13078DDA8C8FA0DAA11`, { params: params }); };



// WEBPACK FOOTER //
// ./src/libs/api.js